// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"243":"159ab4f2","312":"01844f0f","629":"9e391c53","862":"b71d3879"}[chunkId] + ".chunk.js";
};